import React, { Component } from "react";
import './header.css';

class MyHeader extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="headerWrapper">
                <div id="header-image">
                    <img src="https://images.unsplash.com/photo-1526478806334-5fd488fcaabc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1216&q=80"></img>
                </div>
                <div id="header-text">
                    <h1>SexPunktNull</h1>
                    <div className="flexText">
                        <p>Punk.</p>
                        <p>Rock.</p>
                        <p>Metal.</p>
                    </div>
                </div>
                
                
            </div>
        );
    }
}
export default MyHeader;